if (!window.DateCalculatorAbstract) {
  window.DateCalculatorAbstract = class extends HTMLElement {
    constructor() {
      super()

      this.isoCode = this.dataset.isoCode || 'en-US';
      this.useMonday = this.dataset.useMonday === 'true';
      this.leadTime = this.dataset.leadTime ? parseInt(this.dataset.leadTime) : 0
      this.bufferDays = this.dataset.bufferDays ? parseInt(this.dataset.bufferDays) : 0
      this.additionalDays = this.dataset.additionalDays ? parseInt(this.dataset.additionalDays) : 0
      this.safetyDays = this.dataset.safetyDays ? parseInt(this.dataset.safetyDays) : 0

      this.mainElement = this.closest('.product-main-element');
      this.shippingDateUpdateHandler = this.onShippingDateUpdate.bind(this);
    }

    connectedCallback() {
      this.mainElement?.addEventListener('shippingDate:update', this.shippingDateUpdateHandler);
    }

    disconnectedCallback() {
      this.mainElement?.removeEventListener('shippingDate:update', this.shippingDateUpdateHandler);
    }

    onShippingDateUpdate(event) {
      this.estimatedShippingDate = $s.DateCalculator.getEstimatedShippingDate(this.originalShippingDate, {
        leadTime: event.detail.adjustLeadTime,
        bufferDays: event.detail.adjustBufferDays
      });
    }

    init() {
      this.today = new Date().toISOString().slice(0, 10);
      this.startShippingDate = $s.DateCalculator.getStartingMonday(this.today);
      this.estimatedShippingDate = $s.DateCalculator.getEstimatedShippingDate(this.startShippingDate, {
        leadTime: this.leadTime,
        bufferDays: this.bufferDays,
        additionalDays: this.additionalDays
      });
      this.originalShippingDate = this.estimatedShippingDate;
    }
  };
}

if (!customElements.get('estimated-shipping-manager')) {
  class ComponentEstimatedShippingManager extends window.DateCalculatorAbstract {
    constructor() {
      super();

      this.INPUT_CLASS_ID = 'input-delivery-times'
      this.status = 'made-to-order'

      this.orderTypeMadeToOrder = this.dataset.orderTypeMadeToOrder;
      this.orderTypeInStock = this.dataset.orderTypeInStock;
      this.message = this.dataset.message;
      this.messageInStock = this.dataset.messageInStock;
      this.addShadowLineItems = this.dataset.addShadowLineItems === 'true';

      this.stockFilterUpdateHandler = this.onStockFilterUpdate.bind(this);

      this.init()
    }

    init() {
      super.init()

      if (this.isHighVariants && this.mainElement) this.status = this.mainElement.getStockFilterState()

      this.renderFormData()
    }

    connectedCallback() {
      super.connectedCallback();
      this.mainElement?.addEventListener('inStockFilter:update', this.stockFilterUpdateHandler);
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.mainElement?.removeEventListener('inStockFilter:update', this.stockFilterUpdateHandler);
    }

    clearFormData() {
      this.mainElement.querySelector('form')?.querySelectorAll(`input.${this.INPUT_CLASS_ID}`).forEach(el => el.remove())
    }

    onStockFilterUpdate(event) {
      this.status = event.detail.filtered ? 'in-stock' : 'made-to-order';
      this.renderFormData()
    }

    getMessage() {
      const currentDate = this.useMonday ? $s.DateCalculator.getMondayOfWeek(this.estimatedShippingDate) : this.estimatedShippingDate;
      return $s.DateCalculator.getDateMessage(this.message, currentDate)
    }

    onShippingDateUpdate(event) {
      super.onShippingDateUpdate(event);
      this.renderFormData();
    }

    renderFormData() {
      const form = this.mainElement.querySelector('form');
      if (!form || !this.INPUT_CLASS_ID) return;
      this.clearFormData()

      const orderType = this.status === 'in-stock' ? this.orderTypeInStock : this.orderTypeMadeToOrder;
      const deliveryTime = this.status === 'in-stock' ? this.messageInStock : this.getMessage()
      let formData = [
        $s.createInput({ name: `properties[${lngg.cart__delivery_times__order_type}]`, value: orderType, styleClasses: [this.INPUT_CLASS_ID] }),
        $s.createInput({ name: `properties[${lngg.cart__delivery_times__deliver_times}]`, value: deliveryTime.replace(/<[^>]*>/g, ''), styleClasses: [this.INPUT_CLASS_ID] }),
      ]
      if (this.addShadowLineItems) {
        formData = [
          ...formData,
          $s.createInput({ name: `properties[_order_type]`, value: orderType, styleClasses: [this.INPUT_CLASS_ID] }),
          $s.createInput({ name: `properties[_delivery_time]`, value: deliveryTime.replace(/<[^>]*>/g, ''), styleClasses: [this.INPUT_CLASS_ID] }),
        ]
      }
      form.append(...formData.filter(item => item))
    }
  }
  customElements.define('estimated-shipping-manager', ComponentEstimatedShippingManager);
}


if (!customElements.get('estimated-shipping-date')) {
  class ComponentEstimatedShippingDate extends window.DateCalculatorAbstract {
    constructor() {
      super();

      this.messageEl = this.querySelector('.msg')
      this.message = this.dataset.message;

      this.init();
    }

    init() {

      super.init()

      if (!this.message) {
        this.classList.add('hide');
        return;
      }

      this.renderShippingDate()
    }

    renderShippingDate() {
      const currentDate = this.useMonday ? $s.DateCalculator.getMondayOfWeek(this.estimatedShippingDate) : this.estimatedShippingDate;
      this.messageEl.innerHTML = $s.DateCalculator.getDateMessage(this.message, currentDate)
    }

    onShippingDateUpdate(event) {
      super.onShippingDateUpdate(event);
      this.renderShippingDate();
    }

  }
  customElements.define('estimated-shipping-date', ComponentEstimatedShippingDate);
}

if (!customElements.get('wear-date-checker')) {
  class ComponentWearDateChecker extends window.DateCalculatorAbstract {
    constructor() {
      super();

      this.inputDate = this.querySelector('[type="date"]');
      this.btnCheck = this.querySelector('.btn-check');
      this.elFeedback = this.querySelector('.feedback')

      this.messageValidationSuccess = this.dataset.messageValidationSuccess;
      this.messageValidationFail = this.dataset.messageValidationFail;

      this.validateInCart = this.dataset.validateInCart === 'true';

      this.storageKey = this.dataset.storageKey || 'wear-date-checker-date';

      this.onChangeDateHandler = this.onChangeDate.bind(this)
      this.onCheckDateHandler = this.onCheckDate.bind(this)
      this.init()
    }

    init() {

      super.init()

      this.INPUT_CLASS_ID = 'input-wear-dates'
      this.inputDate.min = this.today;
      this.dateAdjustments = []

      // Restore a previously entered date from session storage.
      const savedDate = localStorage.getItem(this.storageKey);
      if (savedDate) {
        this.inputDate.value = savedDate;
        this.validateWearDate();
      }

    }

    onShippingDateUpdate(event) {
      super.onShippingDateUpdate(event);
      this.dateAdjustments = []
      if (event.detail) {
        this.dateAdjustments.push(event.detail)
      }
      this.validateWearDate();
    }

    connectedCallback() {
      super.connectedCallback();
      this.btnCheck?.addEventListener('click', this.onCheckDateHandler)
      this.inputDate.addEventListener('input', this.onChangeDateHandler)
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.btnCheck?.removeEventListener('click', this.onCheckDateHandler)
      this.inputDate.removeEventListener('input', this.onChangeDateHandler)
    }

    validateWearDate() {
      const wearDate = this.inputDate.value;
      if (!wearDate) return;
      const isValidDate = this.isValidWearDate(this.estimatedShippingDate, wearDate, this.safetyDays)
      if (isValidDate) {
        this.unblockForm()
        this.renderFormData()
      } else {
        this.blockForm()
        this.clearFormData()
      }
    }

    onChangeDate(event) {
      const date = this.inputDate.value;
      if (date) {
        localStorage.setItem(this.storageKey, date);
      } else {
        localStorage.removeItem(this.storageKey);
      }
      this.validateWearDate();
    }

    onCheckDate(event) {
      this.validateWearDate()
    }

    removeHtml(html) {
      let doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.body.textContent || "";
    }

    renderShippingDate(message, date, validity = true) {
      const currentDate = this.useMonday ? $s.DateCalculator.getMondayOfWeek(date) : date;
      const displayMessage = $s.DateCalculator.getDateMessage(message, currentDate)
      this.elFeedback.innerHTML = displayMessage;
      const clearDisplayMessage = this.removeHtml(displayMessage)
      if (validity) {
        this.inputDate.setCustomValidity(clearDisplayMessage)
      } else {
        this.inputDate.setCustomValidity('')
      }
    }

    blockForm() {
      this.renderShippingDate(this.messageValidationFail, this.estimatedShippingDate)
      this.classList.remove('valid')
    }

    unblockForm() {
      this.renderShippingDate(this.messageValidationSuccess, this.estimatedShippingDate, false)
      this.classList.add('valid')
    }

    isValidWearDate(estimatedShippingDate, wearDate, safetyDays = 0) {
      return $s.DateCalculator.isValidWearDate(estimatedShippingDate, wearDate, safetyDays)
    }

    clearFormData() {
      if (!this.validateInCart) return;

      this.mainElement.querySelector('form')?.querySelectorAll(`input.${this.INPUT_CLASS_ID}`).forEach(el => el.remove())
    }

    renderFormData() {
      if (!this.validateInCart) return;

      const form = this.mainElement.querySelector('form');
      if (!form) return;
      this.clearFormData()

      let formData = [
        $s.createInput({ name: `properties[${lngg.cart__wear_dates__wear_date}]`, value: this.inputDate.value, styleClasses: [this.INPUT_CLASS_ID] }),
        $s.createInput({ name: 'properties[_wear_date]', value: this.inputDate.value, styleClasses: [this.INPUT_CLASS_ID] }),
        $s.createInput({ name: 'properties[_lead_time]', value: this.leadTime, styleClasses: [this.INPUT_CLASS_ID] }),
        $s.createInput({ name: 'properties[_buffer_days]', value: this.bufferDays, styleClasses: [this.INPUT_CLASS_ID] }),
        $s.createInput({ name: 'properties[_safety_days]', value: this.safetyDays, styleClasses: [this.INPUT_CLASS_ID] }),
      ]

      if (this.dateAdjustments.length > 0) {
        formData = [...formData,
          ...this.dateAdjustments.flatMap((dateAdjustment) => [
            $s.createInput({ name: `properties[_adjust_lead_time]`, value: dateAdjustment.adjustLeadTime, styleClasses: [this.INPUT_CLASS_ID] }),
            $s.createInput({ name: `properties[_adjust_buffer_days]`, value: dateAdjustment.adjustBufferDays, styleClasses: [this.INPUT_CLASS_ID] }),
          ])
        ]
      }
      form.append(...formData.filter(item => item))
    }

  }
  customElements.define('wear-date-checker', ComponentWearDateChecker);
}
